import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import UserContext from 'contexts/User';
import UsersContext from 'contexts/Users';
import CollectionContext from 'contexts/Collections';

import Brochure from './Brochure';
import Share from '../../Brochure/Editor/Share';
import Icon from 'components/Icon';

import { BigBlueButton, StyledSelect } from 'lib/styles';

import {
	Heading,
	HeadColumn,
	FlexRow,
	Head,
	Body,
	Container,
	ListTypeContainer,
} from './styles';

import {
	sortMasterFirst,
	sortDefaultFirst,
	sortNewestFirst,
} from './lib';

const ListType = props => {
	const types = ['tile', 'list'].map(type => {
		const active = type === props.active;
		const iconClass = 'list-type-toggle' + ( active ? ' active' : '' );
		const icon = 'view-' + type

		return (
			<Icon
				key={type}
				tag="button"
				icon={icon}
				iconclass={iconClass}
				onClick={() => props.changeBrowseTypeHandler(type)}
			/>);
	});

	return (
		<ListTypeContainer>
			{types}
		</ListTypeContainer>
	);
}

ListType.propTypes = {
	active: PropTypes.oneOf(['tile', 'list']),
}

class Brochures extends React.Component {
	state = {
	  shareBrochure: null,
	  loadingClone: false,
	}

	shareBrochureHandler = shareBrochure => this.setState({ shareBrochure })

	render() {
	  const props = this.props;
	  const { t, brochures } = props;

	  const sortOptions = [
	    {
	      value: 'date',
	      name: t('building/Brochures/Latest first'),
	    }
	  ];

	  const master = brochures.find(brochure => brochure.type === 'master');

	  return (
	    <CollectionContext.Consumer>
	      {({ collections, collectionHandler }) => (
	        <UserContext.Consumer>
	          {loggedUser => (
	            <UsersContext.Consumer>
	              { users => (
	                <Container>
	                  <Head>
	                    <HeadColumn>
	                      <FlexRow>
	                        <Heading>{t('building/Brochures')}</Heading>
	                        <ListType active={this.props.brochureType} changeBrowseTypeHandler={this.props.changeBrochureTypeHandler} />
	                      </FlexRow>
	                      <StyledSelect
	                        id="sort"
	                        style={{ backgroundColor: 'rgba(0,0,0,0)', padding: 0, height: '24px' }}
	                        options={sortOptions}
	                      />
	                    </HeadColumn>
	                    <HeadColumn end="true">
	                      {
	                        !this.props.loading && ['editor', 'developer'].some(role => loggedUser.role.includes(role)) &&
													<BigBlueButton
													  onClick={() => {
													    this.setState({ loadingClone: true });

													    if (master) {
													      props.cloneBrochureHandler(() => {
													        this.setState({ loadingClone: false });
													      }, master.id);
													    } else {
													      props.createBrochureHandler(() => this.setState({ loadingClone: false }));
													    }
													  }}
													  disabled={this.state.loadingClone}
													>
													  {t('building/Create new brochure')}
													</BigBlueButton>
	                      }
	                    </HeadColumn>
	                  </Head>

	                  <Body type={this.props.brochureType}>
	                    {
	                      [ ...brochures ]
	                        .sort(sortNewestFirst)
	                        .sort(sortDefaultFirst)
	                        .sort(sortMasterFirst)
	                        .map(brochure => {
	                          const user = users.find(user => user.email === brochure.author);
	                          const canAddToCollection = loggedUser.can.create.collections();
	                          const canClone = loggedUser.can.create.brochures();
	                          const canRemove = loggedUser.can.delete.master() || brochure.type === 'normal';
	                          const collection = collections.length ? collections[0] : false;
	                          const brochureInCollection = collection && collection.brochures.includes(brochure.id);

	                          brochure.authorName = '';

	                          if (typeof user !== 'undefined') {
	                            brochure.authorName = `${user.firstName} ${user.lastName}`;
	                          }

							  brochure.contacts = [];

							  if(brochure.content && Array.isArray(brochure.content.contacts)) {
								  brochure.contacts = brochure.content.contacts.map(username => users.find(user => user.username === username)).filter(user => typeof user === 'object');
							  }

	                          return (
	                            <Brochure
	                              key={brochure.id}
	                              type={this.props.brochureType}
	                              brochure={brochure}
	                              collection={collection.locked ? false : collection}
	                              collectionHandler={collectionHandler}
	                              brochureInCollection={brochureInCollection}
	                              baseUrl={props.baseUrl}
	                              canShare={true}
	                              canAddToCollection={canAddToCollection}
	                              canClone={canClone}
	                              canRemove={canRemove}
	                              cloneBrochureHandler={props.cloneBrochureHandler}
	                              deleteBrochureHandler={props.deleteBrochureHandler}
								  shareBrochureHandler={() => this.shareBrochureHandler(brochure.id)}
								  building={this.props.building}
								  updateBuildingHandler={this.props.updateBuildingHandler}
	                            />
	                          )
	                        })
	                    }
	                  </Body>
	                  {
	                    this.state.shareBrochure !== null &&
										<Share
										  brochure={brochures.find(b => b.id === this.state.shareBrochure)}
										  baseUrl={this.props.baseUrl}
										  toggleGeneratePdfOpen={() => this.shareBrochureHandler(null)}
										/>
	                  }
	                </Container>
	              )}
	            </UsersContext.Consumer>
	          )}
	        </UserContext.Consumer>
	      )}
	    </CollectionContext.Consumer>
	  );
	}
}

Brochures.propTypes = {
	t: PropTypes.func,
	loading: PropTypes.bool,
	brochures: PropTypes.array,
	brochureType: PropTypes.string,
	building: PropTypes.object,
	updateBuildingHandler: PropTypes.func,
	baseUrl: PropTypes.string,
	deleteBrochureHandler: PropTypes.func,
	createBrochureHandler: PropTypes.func,
	cloneBrochureHandler: PropTypes.func,
	changeBrochureTypeHandler: PropTypes.func,
}

export default translate('translations')(Brochures)
